import(/* webpackMode: "eager", webpackExports: ["QuerySpy"] */ "/vercel/path0/packages/docs/src/app/playground/(demos)/_components/query-spy.tsx");
